import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-administration-menu-component',
  templateUrl: './menu.component.html'
})
export class AdministrationMenuComponent {

  constructor(route: ActivatedRoute) {

   route.params.subscribe(params => console.log("side menu id parameter", params['id']));

  }
}
